show_email_dialog = function(initial_values, callback){
	var title = 'Add Email address';
	var definition = {
		title: title,
		formDef: {type: 'SimpleForm',
			fields: [
				{name: 'email_me', type: 'ChoiceField', label: 'Do you want this report to be mailed to you?', initial_value: 'function', args: {options: [{value:'true', text:'True'},{value:'false', text:'False'}]} },
				{name: 'email_address', type: 'TextField', label: 'Add email address'}
			]
		},
		initialValues: initial_values.initialValues
	};

	Grape.show_dialog('GrapeFormDialog', definition,
	{
		onClose: function(answer) {
			$.postJSON('/sr/report/create',
				answer,
				callback
			);
		}
	});
};

show_report_definition_dialog = function(bindings, callback){
	var title;
	var action;
	var definition;
	var form_scope_list = [];

	// console.log(bindings);

	if(!bindings.initialValues.report_definition_id)
	{
		title = 'Add Report Definition';
		action = 'create';
	}
	else
	{
		title = 'Edit Report Definition';
		action = 'edit';
	}

	var get_scope_form_data = function() {
		var scope_params = {
			schema: 'gf',
			tablename: 'scope',
			sortfield: 'scope_id',
			limit: 5000
		};

		$.postJSON("/grape/list", scope_params, function(data){
			form_scope_list = [];
			if (data.result_count > 0)
			{
				data.records.forEach(function(record) {
					form_scope_list.push({"value": record.scope_id, "text": record.name});
				});
			}
			create_form_definition();
		});
	};

	var create_form_definition = function(){
		definition = {
			title: title,
			formDef: {type: 'SimpleForm',
				fields: [
					{name: 'report_definition_name', type: 'TextField', label: 'Report Definition Name'},
					{name: 'report_definition_description', type: 'TextField', label: 'Report Definition Description'},
					{name: 'report_definition_group', type: 'TextField', label: 'Report Group'},
					{name: 'report_type', type: 'ChoiceField', label: 'Report Type', args: {options: [{value:'function', text:'Function'},{value:'query', text:'Query'}]} },
					{name: 'query_sql', type: 'TextAreaField', label: 'Report query SQL (for query reports)'},
					{name: 'function_schema', type: 'TextField', label: 'Report function schema (for function reports)'},
					{name: 'function_name', type: 'TextField', label: 'Report function name (for function reports)'},
					{name: 'form_scope_id', type: 'ChoiceField', label: 'Form Scope', args: {options: form_scope_list} }
				]
			},
			initialValues: bindings.initialValues
		};

		if(action === 'edit')
		{
			definition.formDef.fields[0].args = {
				widget: {
					type: 'TemplateWidget',
					args: {
							template_string: `<input type="string" class="value form-control" disabled=true/>`
					}
				}
			};
			definition.formDef.initialValues = bindings.initialValues;
		}

		Grape.show_dialog('GrapeFormDialog', definition,
		{
			onClose: function(answer) {
				if (answer) {
					if(action === 'create')
					{
						if (!answer.form_scope_id) {
							answer.form_scope_id = null;
						}
						$.postJSON(
							'/sr/collection/save',
							answer,
							callback
						);
					}
					else // action === 'edit'
					{
						answer.report_definition_id = bindings.initialValues.report_definition_id;
						answer.report_definition_name = bindings.initialValues.report_definition_name; //Prevents user from changing the report definition name
						// Maybe alert the user?
						if (!answer.form_scope_id) {
							answer.form_scope_id = null;
						}
						var function_values = Object.assign(bindings.initialValues, answer);
						$.postJSON(
							'/sr/collection/edit',
							function_values,
							callback
						);
					}
				}
			}
		});
	};
	get_scope_form_data();
};

user_email_list_dialog = function(bindings, callback){
	var title;
	var action;

	if (!bindings.initialValues.list_id )
	{
		title = 'Add Email List';
		action = 'create';
	}
	else
	{
		title = 'Edit Email List';
		action = 'edit';
	}

	var definition = {
		title: title,
		formDef: {type: 'SimpleForm',
			fields: [
				{name: 'title', type: 'TextField'},
				{name: 'users', type: 'bs-multiselect', args: { list : bindings.user_list} },
				{name: 'roles', type: 'bs-multiselect', args:{ list: bindings.roles} },
				{name: 'address_strings', type: 'ArrayField', args: {
						field: { type: 'TextField', args: {} },
					}
				}
			]
		},
		initialValues: bindings.initialValues
	};

	Grape.show_dialog('GrapeFormDialog', definition,
	{
		onClose: function(answer) {
			if (answer) {
				// Set fields to empty array manually until bug is fixed in grape-forms
				answer.users = answer.users || [];
				answer.roles = answer.roles || [];
				if(action === 'create')
				{
					$.postJSON(
						'/sr/email_list/save',
						answer,
						callback
					);
				}
				else if(action === 'edit')
				{
					var function_values = Object.assign(bindings.initialValues, answer);
					$.postJSON(
						'/sr/email_list/update',
						function_values,
						callback
					);
				}
			}
		}
	});
};

var template$8 = "<div class=\"modal-dialog modal-md\">\n\t<div class=\"modal-content\">\n\t\t<!-- HEADER -->\n\t\t<div class=\"modal-header\">\n\t\t\t<!-- TITLE -->\n\t\t\t<h3 class=\"modal-title\">\n\t\t\t\t<div data-bind=\"html: title\"></div>\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<!-- BODY -->\n \t\t<div class=\"modal-body\">\n\t\t\t<div class=\"panel panel-default\" style=\"border: 0\">\n\t\t\t\t<table border=\"0\" class=\"table\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right\">Email Title:</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Email title\" data-bind=\"textInput: email_title\">\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right\">Select Users To Be Mailed:</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<select class=\"multiple-select\" multiple=\"multiple\" style=\"width: 100%;\" data-bind=\"options: availableUsers, selectedOptions: selectedAvailableUsers\"></select>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right\">Select User Roles To Be Mailed:</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<select class=\"multiple-select\" multiple=\"multiple\" style=\"width: 100%;\" data-bind=\"options: availableRoleNames, selectedOptions: selectedAvailableRoleNames\" size=\"10\"></select>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right\">Add Extra Email Address:\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnAdd_click\" title=\"Add Email Address\">\n\t\t\t\t\t\t\t\t<span class=\"fa fa-plus\"></span>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<!-- ko foreach: $root.extra_email_address -->\n\t\t\t\t\t\t\t<div style=\"padding-bottom: 3px;\">\n\t\t\t\t\t\t\t\t<div class=\"pull-right\" style=\"margin-left:5px\">\n\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnRemove_click\" title=\"Remove Email Address\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"fa fa-remove\"></span>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<input type=\"text\" style=\"width: 80%;\" class=\"form-control input input-sm\" placeholder=\"Email address....\" data-bind=\"textInput: $data.value\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- /ko -->\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- FOOTER -->\n\t\t<div class=\"modal-footer\">\n\t\t\t<div class=\"btn-group\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnSave_click\">Save</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnClose_click\">Close</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

let UserEmailListDialogViewModel = function(page)
{
	const self = this;
	this.page = page;
	this.title = ko.observable();
	this.action = ko.observable();
	this.email_title = ko.observable('');
	this.availableUsers = ko.observableArray();
	this.selectedAvailableUsers = ko.observableArray();
	this.availableRoleNames = ko.observableArray();
	this.selectedAvailableRoleNames = ko.observableArray();
	self.extra_email_address = ko.observableArray();
	self.extraEmailList = ko.observableArray();
	// KNOCKOUT OBSERVABLES GOES HERE
};

let UserEmailListDialog = function(bindings) // bindings here will contain the data sent via Grape.show_dialog(name, data, options)
{
	let self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new UserEmailListDialogViewModel(this); // Name of the ViewModel defined above
	this.name = 'UserEmailListDialog'; // Unique dialog name

	this.init = function() {
		$('.multiple-select').select2();

		Grape.cache.fetch('AccessRoles', function(d) {
			let arr = [];
			d.forEach(function(s) { if (['all', 'guest', 'any'].indexOf(s.role_name) == -1) arr.push(s.role_name); });
			self.viewModel.availableRoleNames(arr);

			if (self.bindings.initialValues.roles)
				self.viewModel.selectedAvailableRoleNames(self.bindings.initialValues.roles);
		});

		let params = {
			tablename: 'v_users',
			schema: 'grape',
			sortfield: 'username'
		};

		$.postJSON('/grape/list', params, function(results) {
			if (results.result_count == 0)
				results.records = [];

			let arr = [];
			results.records.forEach(function(s) { arr.push(s.username); });
			self.viewModel.availableUsers(arr);

			if (self.bindings.initialValues.users)
				self.viewModel.selectedAvailableUsers(self.bindings.initialValues.users);
		});

		if (!bindings.initialValues.list_id ) {
			self.viewModel.title('Add Email List');
			self.viewModel.action('create');
		}
		else {
			self.viewModel.title('Edit Email List');
			self.viewModel.action('edit');
			self.viewModel.email_title(self.bindings.initialValues.title);
			self.bindings.initialValues.address_strings.forEach(function(s) { self.viewModel.extra_email_address.push({ value: ko.observable(s)}); });
		}
	};

	this.btnAdd_click = function() {
		self.viewModel.extraEmailList([]);
		self.viewModel.extra_email_address.push({ value: ko.observable('')});
	};

	this.btnRemove_click = function() {
		self.viewModel.extra_email_address.remove(this);
	};

	this.btnClose_click = function() {
		self.close(false);
	};

	this.btnSave_click = function() {
		self.viewModel.extra_email_address().forEach(function(data){
			self.viewModel.extraEmailList().push(data.value());
		});

		let params = {
			title: self.viewModel.email_title(),
			users: self.viewModel.selectedAvailableUsers(),
			roles: self.viewModel.selectedAvailableRoleNames(),
			address_strings: self.viewModel.extraEmailList()
		};

		if(self.viewModel.action() === 'create') {
			$.postJSON(
				'/sr/email_list/save',
				params,
				function() { self.close(); }
			);
		}
		else if(self.viewModel.action() === 'edit') {
			params.list_id = self.bindings.initialValues.list_id;
			params.email_list_owner = self.bindings.initialValues.email_list_owner;
			$.postJSON(
				'/sr/email_list/update',
				params,
				function() { self.close(); }
			);
		}
	};
};

var user_email_list = {
	name: 'UserEmailList',
	dialog_class: UserEmailListDialog,
	template: template$8
};

var template$7 = "<div class=\"modal-dialog modal-lg\">\n\t<div class=\"modal-content\">\n\t\t<div class=\"modal-header\">\n\t\t\t<h3 class=\"modal-title grape_dialogheader\">\n\t\t\t\t<span data-bind=\"html: title\"></span>\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<div class=\"modal-body\">\n\t\t\t<table border=\"0\" class=\"table\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Report Definition Name:</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Report definition name\" data-bind=\"textInput: report_definition_name\">\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Report Definition Description:</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Report definition description\" data-bind=\"textInput: report_definition_description\">\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Report Definition Group:</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Report definition group\" data-bind=\"textInput: report_definition_group\">\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Report Type:</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<select style=\"width: 100%;\" data-bind=\"options: availableTypes, value: selectedType\" class=\"form-control input input-sm\"></select>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<!-- ko if: $root.selectedType() == 'View' -->\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Select View:</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<select style=\"width: 100%;\" data-bind=\"options: availableViews, value: selectedView, optionsCaption: 'Choose View'\" class=\"form-control input input-sm\"></select>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t<!-- /ko -->\n\t\t\t\t<!-- ko if: $root.selectedType() == 'Function' -->\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"font-weight: bold; text-align: right;\">Select Function:</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<select style=\"width: 100%;\" data-bind=\"options: availableFunctions, value: selectedFunction, optionsCaption: 'Choose Function'\" class=\"form-control input input-sm\"></select>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t<!-- /ko -->\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"modal-footer\">\n\t\t\t<div class=\"btn-group\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnSave_click\">Save</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnClose_click\">Close</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

let ReportDefinitionDialogViewModel = function (page) {
	let self = this;
	self.page = page;
	this.dialog_title = ko.observable('');
	this.action = ko.observable('');
	this.report_definition_name = ko.observable('');
	this.report_definition_description = ko.observable('');
	this.report_definition_group = ko.observable('');
	this.availableTypes = ko.observableArray(['View', 'Function']);
	this.selectedType = ko.observableArray(['View']);

	this.availableViews = ko.observableArray([]);
	this.selectedView = ko.observableArray([]);
	this.availableFunctions = ko.observableArray([]);
	this.selectedFunction = ko.observableArray([]);

	this.title = ko.computed(function() {
		return self.dialog_title();
	}, this);
	// KNOCKOUT OBSERVABLES GOES HERE
};

let ReportDefinitionDialog = function (bindings) // bindings here will contain the data sent via Grape.show_dialog(name, data, options)
{
	let self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new ReportDefinitionDialogViewModel(this); // Name of the ViewModel defined above
	this.name = 'ReportDefinitionDialog'; // Unique dialog name

	this.init = function () {
		$.postJSON('/sr/get_views_and_functions', {} , function(results){
			if (results.status != 'OK'){
				Grape.alert({
					type: 'warning',
					message: 'No data found'});
				return;
			}
			else {
				let v_arr = [];
				let f_arr = [];

				if (results.views != null) {
					results.views.forEach(function(s) { v_arr.push(s); });
					self.viewModel.availableViews(v_arr);
				}

				if (results.functions != null) {
					results.functions.forEach(function(s) { f_arr.push(s); });
					self.viewModel.availableFunctions(f_arr);
				}
				self.load_data();
			}
		});
	};

	this.load_data = function() {
		if(!self.bindings.initialValues.report_definition_id)
		{
			self.viewModel.dialog_title('Add Report Definition');
			self.viewModel.action('create');
		}
		else
		{
			self.viewModel.dialog_title('Edit Report Definition');
			self.viewModel.action('edit');
			self.viewModel.report_definition_name(self.bindings.initialValues.report_definition_name);
			self.viewModel.report_definition_description(self.bindings.initialValues.report_definition_description);
			self.viewModel.report_definition_group(self.bindings.initialValues.report_definition_group);
			self.viewModel.selectedType(self.bindings.initialValues.report_type.charAt(0).toUpperCase() + self.bindings.initialValues.report_type.slice(1));
			self.bindings.initialValues.selected_view ? '' : self.viewModel.selectedFunction(self.bindings.initialValues.selected_function);
			self.bindings.initialValues.selected_function ? '' : self.viewModel.selectedView(self.bindings.initialValues.selected_view);
		}
	};

	this.btnClose_click = function () {
		self.close(false);
	};

	this.btnSave_click = function () {
		let params = {
			report_definition_name : self.viewModel.report_definition_name(),
			report_definition_description: self.viewModel.report_definition_description(),
			report_definition_group: self.viewModel.report_definition_group(),
			report_type: self.viewModel.selectedType(),
			selected_view: self.viewModel.selectedView(),
			selected_function: self.viewModel.selectedFunction()
		};
		
		if (self.viewModel.selectedType() === 'View' && typeof self.viewModel.selectedView() === 'undefined') {
			Grape.alert({
				type: 'warning',
				message: 'No view selected'});
			return;
		} else if (self.viewModel.selectedType() === 'Function' && typeof self.viewModel.selectedFunction() === 'undefined') {
			Grape.alert({
				type: 'warning',
				message: 'No function selected'});
			return;
		}
		else {
			if (self.viewModel.action() === 'create')
			{
				params.report_definition_id = null;
				params.report_definition_version = null;
				$.postJSON(
					'/sr/collection/save',
					params,
					function(data) { self.close(data); }
				);
			}
			else // action === 'edit'
			{
				params.report_definition_id = self.bindings.initialValues.report_definition_id;
				params.report_definition_version = self.bindings.initialValues.report_definition_version;
				params.report_definition_name = self.viewModel.report_definition_name();
				$.postJSON(
					'/sr/collection/edit',
					params,
					function(data) { self.close(data); }
				);
			}
		}
	};
};

var report_definition$1 = {
	name: 'ReportDefinition',
	dialog_class: ReportDefinitionDialog,
	template: template$7
};

var template$6 = "<div class=\"modal-dialog modal-md\">\n\t<div class=\"modal-content\">\n\t\t<div class=\"modal-header\">\n\t\t\t<h3 class=\"modal-title\">\n\t\t\t\t<div>Select Email List</div>\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<div class=\"modal-body\">\n\t\t\t<table border=\"0\" class=\"table\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"font-weight: bold; text-align: right\">Available Email Lists:</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<select style=\"width: 100%;\" class=\"form-control input input-sm\" data-bind=\"options: availableList, selectedOptions: selectedAvailableList\"></select>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div class=\"modal-footer\">\n\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnSend_click\">Send</button>\n\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnClose_click\">Close</button>\n\t\t</div>\n\t</div>\n</div>";

let EmailDialogViewModel = function (page) {
	let self = this;
	self.page = page;
	this.availableList = ko.observableArray();
	this.selectedAvailableList = ko.observable();
	// KNOCKOUT OBSERVABLES GOES HERE
};

let EmailDialogClass = function (bindings) // bindings here will contain the data sent via Grape.show_dialog(name, data, options)
{
	let self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new EmailDialogViewModel(this); // Name of the ViewModel defined above
	this.name = 'EmailDialog'; // Unique dialog name

	this.init = function () {
		let arr = [];
			self.bindings.forEach(function(s) { arr.push(s.title); });
		self.viewModel.availableList(arr);
	};

	this.btnSend_click = function () {
		this.page.close(self.viewModel.selectedAvailableList());
	};

	this.btnClose_click = function () {
		self.close(false);
	};
};

var send_email = {
	name: 'EmailDialog',
	dialog_class: EmailDialogClass,
	template: template$6
};

var template$5 = "<div class=\"modal-dialog modal-md\">\n\t<div class=\"modal-content\">\n\t\t<div class=\"modal-header\">\n\t\t\t<h3 class=\"modal-title\">\n\t\t\t\t<div>Please Enter Criteria For Function</div>\n\t\t\t</h3>\n\t\t</div>\n\n\t\t<div class=\"modal-body\">\n\t\t\t<td style=\"font-weight: bold; text-align: right\">Add Extra Variable:\n\t\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnAdd_click\" title=\"Add Email Address\">\n\t\t\t\t\t<span class=\"fa fa-plus\"></span>\n\t\t\t\t</button>\n\t\t\t</td>\n\t\t\t<!-- ko foreach: $root.extra_variable -->\n\t\t\t<table>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>Variable</td>\n\t\t\t\t\t<td>Value</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td style=\"width: 45%;\">\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Key information ....\" data-bind=\"textInput: $data.key\">\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=\"width: 45%;\">\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input input-sm\" placeholder=\"Variable information ....\" data-bind=\"textInput: $data.value\">\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<div class=\"pull-right\" style=\"margin-left:5px\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnRemove_click\" title=\"Add Variable\">\n\t\t\t\t\t\t\t\t<span class=\"fa fa-remove\"></span>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t\t<!-- /ko -->\n\t\t</div>\n\n\t\t<div class=\"modal-footer\">\n\t\t\t<div class=\"btn-group\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-success\" data-bind=\"click: $root.page.btnSave_click\">Save</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" data-bind=\"click: $root.page.btnClose_click\">Close</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

var FunctionDialogViewModel = function (page) {
	var self = this;
	self.page = page;
	self.extra_variable = ko.observableArray();
	self.extraVariableList = ko.observableArray();
	// KNOCKOUT OBSERVABLES GOES HERE
};

var FunctionDialog = function (bindings) // bindings here will contain the data sent via Grape.show_dialog(name, data, options)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new FunctionDialogViewModel(this); // Name of the ViewModel defined above
	this.name = 'FunctionDialog'; // Unique dialog name

	this.init = function () {
	};

	this.btnAdd_click = function() {
		self.viewModel.extraVariableList([]);
		self.viewModel.extra_variable.push({ key: ko.observable(''), value: ko.observable('')});
	};

	this.btnRemove_click = function() {
		self.viewModel.extra_variable.remove(this);
	};

	this.btnSave_click = function() {
		self.viewModel.extra_variable().forEach(function(data){
			self.viewModel.extraVariableList().push({ key: data.key(), value:data.value() });
		});

		self.close(self.viewModel.extraVariableList());
	};

	this.btnClose_click = function() {
		self.close(false);
	};
};

var function_dialog = {
	name: 'FunctionDialog',
	dialog_class: FunctionDialog,
	template: template$5
};

var dialogs = [
	user_email_list,
	report_definition$1,
	send_email,
	function_dialog
];

var template$4 = "<!-- PAGE -->\n<div class=\"container grape\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<span class=\"page_header\">Report Menu\n\t\t\t\t<i class=\"fa fa-question-circle help_icon\" data-autobind=\"btnhelp\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n<hr>\n<div class=\"container grape\">\n\t<div class=\"row\">\n\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t<div class=\"columns columns-left btn-group pull-left\">\n\t\t\t\t<select data-bind=\"options: collection.available_groups, value: collection.selected_group\" class=\"form-control\"></select>\n\t\t\t</div>\n\t\t\t<div class=\"columns columns-right btn-group pull-right\">\n\t\t\t\t<div>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" name=\"toggle\" aria-label=\"toggle\" title=\"Add Report Definition\" data-bind=\"click: collection.add_report\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"glyphicon glyphicon-plus\" style=\"data-buttons-align\"></i>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" name=\"toggle\" aria-label=\"toggle\" title=\"Show / Hide inactive\" data-bind=\"click: collection.show_inactive\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"fa fa-eye-slash\" style=\"data-buttons-align\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<table id=\"report_defnitions_table\"></table>\n\t\t</div>\n\t</div>\n</div>\n";

// import show_report_definition_dialog from './report_definition_dialogs.js';

var ReportMenuViewModel = function(page)
{
	var self = this;
	this.self = self;
	self.page = page;
	self.collection = {
		report_definitions: ko.observableArray([]),
		available_groups: ko.observableArray([]),
		selected_group: ko.observable(''),
		cached_selected_group: ko.observable(),
		hide_inactive_definitions: ko.observable(true),
		cached_hide_inactive_definitions: ko.observable()
	};
	self.table = $("#report_defnitions_table");
	self.session_id = Grape.currentSession.session_id.substring(23, 29);

	self.collection.get_report_definitions = function(){
		var group_value = self.collection.cached_selected_group();
		if ((!group_value) || group_value == 'Choose Collection Group')  {
			group_value = null;
		}
		$.postJSON("/sr/report_definition/get_all", {'group': group_value, 'active': self.collection.cached_hide_inactive_definitions()}, function (d){
			self.collection.report_definitions(d.records);
		});
	};

	self.collection.add_report = function(event) {
		// Create report by calling the show_report_definition_dialog
		var bindings = {
			initialValues : {}
		};

		show_report_definition_dialog(bindings, self.collection.get_report_definitions);
	};

	self.collection.show_inactive = function() {
		self.collection.hide_inactive_definitions( (! self.collection.hide_inactive_definitions()) );
	};
};

var ReportMenuPage = function(bindings) {
	var self = this;
	this.self = self;
	self.bindings = bindings;
	self.viewModel = new ReportMenuViewModel(this);
	self.name = 'ReportMenuPage';
	self.has_data = false;

	self.init = function() {
		self.viewModel.collection.report_definitions.subscribe(function(newValue) {
			//self.viewModel.table.parent().find('.empty-warning').remove();
			if ($.isArray(newValue) && newValue.length > 0)
				self.viewModel.table.bootstrapTable('load',newValue);
			else
				self.viewModel.table.bootstrapTable('load', []);
			//	self.viewModel.table.after('<div class="empty-warning">No report-definitions matches the search criteria</div>');
		});

		self.viewModel.collection.cached_selected_group(
			sessionStorage.getItem( self.session_id + "_selected_group") || 'Choose Collection Group' );

		var show_inactive = sessionStorage.getItem( self.session_id + "_active" );

		if (show_inactive === 'false')
			show_inactive = false;
		else
			show_inactive = true;
		self.viewModel.collection.cached_hide_inactive_definitions(show_inactive);

		self.viewModel.collection.hide_inactive_definitions.subscribe(function(newValue){
			if (self.has_data) {
				sessionStorage.setItem( self.session_id + "_active", newValue );
				self.viewModel.collection.cached_hide_inactive_definitions(newValue);
				self.updateData();
			}		});

		self.viewModel.collection.selected_group.subscribe(function(newValue) {
			if (self.has_data)
			{
				sessionStorage.setItem( self.session_id + "_selected_group", self.viewModel.collection.selected_group() );
				self.viewModel.collection.cached_selected_group(self.viewModel.collection.selected_group());
				self.updateData();
			}		});

		var columns = [
			{field: 'report_definition_name', title: 'Report Definition Name', searchable: true},
			{field: 'report_definition_description', title: 'Report Definition Description'},
			{field: 'report_definition_group', title: 'Report Group', searchable: true},
			{field: 'report_definition_version', title: 'Report Definition Version'},
			{field: 'active', title: 'Active'}
		];

		self.viewModel.table.bootstrapTable({
			classes: 'table table-no-bordered table-condensed table-responsive table-hover',
			pagination: true,
			search: true,
			sortable: true,
			sortOnEnterKey: true,
			sidePagination: 'client',
			dataId: 'field_id',
			columns: columns,
			striped: true,
			pageSize: 100,
			showLoading: true,
			onClickRow: function(row) {
				var url = ["/grape-reports/definition", row.report_definition_id, row.report_definition_version ].join('/');
				Finch.navigate(url);
			},
			rowStyle: function(row, index) {
				return {
					css: {"cursor": "pointer"}
				};
			},
			totalRows: 0
		});
	};

	self.updateData = function() {
		var available_groups = [];
		$.postJSON("/sr/report_definition/get_all_groups", {'active': self.viewModel.collection.cached_hide_inactive_definitions()}, function (d){
			d.records.forEach(function(record) {
				if(available_groups.indexOf(record.report_definition_group) == -1){
					available_groups.push(record.report_definition_group);
				}
			});
			available_groups.unshift('Choose Collection Group');
			let old_value = self.viewModel.collection.selected_group();
			self.viewModel.collection.available_groups(available_groups);
			self.viewModel.collection.selected_group(old_value);
			self.viewModel.collection.selected_group(self.viewModel.collection.cached_selected_group());
			self.viewModel.collection.hide_inactive_definitions(self.viewModel.collection.cached_hide_inactive_definitions());
			self.has_data = true;
		});
		self.viewModel.collection.get_report_definitions();
	};

	self.btnhelp_click = function() {
		Grape.show_help('/sr/help/report_menu_help.html');
	};
};

var report_menu = {
	route: '[/]grape-reports/',
	page_class: ReportMenuPage,
	template: template$4
};

var template$3 = "<!-- PAGE -->\n<div class=\"div_fixed\">\n\t<div class=\"container-fluid grape\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"col-md-1\"></div>\n\n\t\t\t<div class=\"col-md-10\" style=\"text-align:center;\">\n\t\t\t\t<span class=\"page_header\" style=\"display:inline;\">\n\t\t\t\t\t<span data-bind=\"text: report_definition.title\"></span>\n\t\t\t\t\t<span><i class=\"fa fa-question-circle help_icon fa-2x\" data-autobind=\"btnhelp\"></i></span>\n\t\t\t\t</span>\n\t\t\t<br>\n\t\t\t\t<span data-bind=\"text: report_definition.report_definition_description\"></span>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-md-1\">\n\t\t\t\t<div class=\"columns columns-right btn-group pull-right\">\n\t\t\t\t\t<h4 badge>\n\t\t\t\t\t\t<span class=\"label label-warning\" style=\"padding: 8px; border-radius: 8px;\">\n\t\t\t\t\t\t\tReport Definition Version : <span data-bind=\"text: report_definition.report_definition_version\"></span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</h4>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<hr>\n\t<div class=\"container-fluid grape\">\n\t\t<div class=\"col-md-12 pull-left\">\n\t\t\t<button class=\"btn btn-primary backy_button\" data-bind=\"click:backToReports\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Navigate to Report Selection Page.\">\n\t\t\t\t<span class=\"fa fa-lg fa-chevron-left\"></span> Back to Report\n\t\t\t</button>\n\n\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: copyLink.bind($data, 'latest')\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Copy link to latest report\">\n\t\t\t\t<span class=\"fa fa-clone\"></span> Copy Link to Latest Report\n\t\t\t</button>\n\n\t\t\t<button type=\"button\" class=\"btn btn-primary\" title=\"Generate Report\" data-bind=\"click: generateReport\">\n\t\t\t\t<span class=\"fa fa-cog\"></span> Generate New Report\n\t\t\t</button>\n\n\t\t\t<!-- ko if: report_definition.active() == true -->\n\t\t\t\t<button type=\"button\" class=\"btn btn-warning\" title=\"Deactivate / Activate Report Definition\" data-bind=\"click: changeActiveReportDefinition\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t<span class=\"fa fa-ban\"></span> Deactivate\n\t\t\t\t</button>\n\t\t\t<!-- /ko -->\n\t\t\t<!-- ko if: report_definition.active() == false -->\n\t\t\t\t<button type=\"button\" class=\"btn btn-success\" title=\"Deactivate / Activate Report Definition\" data-bind=\"click: changeActiveReportDefinition\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t<span class=\"fa fa-ban\"></span> Activate\n\t\t\t\t</button>\n\t\t\t<!-- /ko -->\n\t\t\t\t<button class=\"btn btn-primary refresh\" data-bind=\"click:page.updateData\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Refresh For Latest Data.\">\n\t\t\t\t\t<span class=\"fa fa-refresh\"></span>\n\t\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<br>\n\t<div class=\"container-fluid grape\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"alert alert-info clearfix\">\n\t\t\t\t<!-- ko if: report_definition.report_type() === 'query' -->\n\t\t\t\t\t<div style=\"max-height:200px; overflow: scroll;\">\n\t\t\t\t\t\t<span data-bind=\"text: report_definition.query_text\"></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary pull-right\" title=\"Edit Query Text\" data-bind=\"click: editReportQuery\" valign=\"center\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"glyphicon glyphicon-pencil\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t<!-- /ko -->\n\t\t\t\t<!-- ko if: report_definition.report_type() === 'function' -->\n\n\t\t\t\t\t<span data-bind=\"text: report_definition.function_schema\"></span>\n\t\t\t\t\t<span>.</span>\n\t\t\t\t\t<span data-bind=\"text: report_definition.function_name\"></span>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary pull-right\" title=\"Edit Function Details\" data-bind=\"click: editReportQuery\" valign=\"center\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"glyphicon glyphicon-pencil\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t<!-- /ko -->\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"container-fluid grape\">\n\t<div class=\"col-md-12\">\n\t\t<div class=\"column\" class=\"report_content\">\n\t\t\t<table class=\"table\" id=\"result_table\"></table>\n\t\t</div>\n\t</div>\n</div>\n";

var ReportDefinitionViewModel = function(page){
	var self = this;
	this.self = self;
	self.page = page;
	var table = $('#result_table');

	self.report_definition = {
		report_definition_description: ko.observable('Placeholder'),
		report_definition_group: ko.observable('Placeholder'),
		report_definition_id: ko.observable(''),
		report_definition_version: ko.observable(''),
		title: ko.observable('Placeholder'),
		query_text: ko.observable('Placeholder'),
		report_type: ko.observable('Placeholder'),
		function_schema: ko.observable('Placeholder'),
		function_name: ko.observable('Placeholder'),
		form_scope_id: ko.observable('Placeholder'),
		active: ko.observable('Placeholder'),
		report_id : ko.observableArray([])
	};

	self.dateFormatter = function(value, row, index) {
		return moment(value).format('YYYY-MM-DD HH:mm');
	};

	// Fetch report definition based on the report definition id
	self.report_definition.get_report_definition = function(){
		var initial_params = {
			schema: 'sr',
			tablename: 'report_definition',
			filter: [
				{field: 'report_definition_id', operand: '=', value: self.report_definition.report_definition_id()},
				{field: 'report_definition_version', operand: '=', value: self.report_definition.report_definition_version()}
			]
		};

		var runtime_formatter = function(value){
			let runtime;
			if (value)
				runtime = moment.duration(value).humanize();

			return runtime;
		};

		$.postJSON("/grape/list", initial_params, function(results){
			self.report_definition.title(results.records[0].report_definition_name);
			self.report_definition.report_definition_description(results.records[0].report_definition_description);
			self.report_definition.report_definition_group(results.records[0].report_definition_group);
			self.report_definition.query_text(results.records[0].query_sql);
			self.report_definition.report_type(results.records[0].report_type);
			self.report_definition.function_schema(results.records[0].function_schema);
			self.report_definition.function_name(results.records[0].function_name);
			self.report_definition.form_scope_id(results.records[0].form_scope_id);
			self.report_definition.report_definition_version(results.records[0].report_definition_version);
			self.report_definition.active(results.records[0].active);

			$.postJSON("/sr/report_definition/select", {'report_definition_id':self.report_definition.report_definition_id(), 'report_definition_version': self.report_definition.report_definition_version()}, function(response, searchText){
				if ($.isArray(response.records) && response.records.length > 0) {
					for (var i = 0; i < response.records.length; i++){
						response.records[i].date_inserted = self.dateFormatter(response.records[i].date_inserted);
						self.report_definition.report_id.push({"list_value_field":response.records[i].report_id, "list_label_field": response.records[i].report_id});

						if (response.records[i].report_function_criteria) {
							response.records[i].report_function_criteria = JSON.stringify(response.records[i].report_function_criteria);
						}
						else
							response.records[i].report_function_criteria = '-';
					}

					// self.report_definition.results.result_data(response);
					table.bootstrapTable('destroy');
					table.bootstrapTable({
						classes: 'table table-no-bordered table-condensed table-responsive table-hover',
						pagination: true,
						sidePagination: 'client',
						columns: [
							{field: 'date_inserted', title: 'Generated At', sortable: true, searchable: true, width:'10%'},
							{field: 'report_id', title: 'Report ID', sortable: true, searchable: true, width:'1%'},
							{field: 'report_function_criteria', title: 'Criteria', sortable: true, searchable: true},
							{field: 'generated_by', title: 'Generated By', sortable: true, searchable: true, width:'1%'},
							{field: 'runtime', title: 'Runtime', sortable: true, searchable: true, width:'1%', formatter: runtime_formatter}
						],
						striped: true,
						pageSize: 100,
						totalRows: response.records.length,
						data: response.records,
						search: true,
						sortName : 'active',
						sortOrder : 'desc',
						// onSearch: self.generateReport(result_table, 'AlbanK');
						rowStyle: function(row, index) {
							return {
								css: {"cursor": "pointer"}
							};
						},
						onClickRow: function(row) {
							var url = ["/grape-reports/report", String(self.report_definition.report_definition_id()), String(self.report_definition.report_definition_version()), String(row.report_id)].join('/');
							Finch.navigate(url);
						}
					});
				}
				else
					table.bootstrapTable('load', response);
			});
		});
	};

	self.generateReport = function(){
		var bindings = {
			initialValues : {
				'report_definition_id': self.report_definition.report_definition_id(),
				'report_definition_version': self.report_definition.report_definition_version(),
				'report_type': self.report_definition.report_type(),
				'function_schema': self.report_definition.function_schema(),
				'function_name': self.report_definition.function_name(),
				'active':true
			}
		};

		self.createReportCall = function(dialog_bindings) {
			var func_var;
			if (dialog_bindings) {
				func_var = {...bindings.initialValues, ...dialog_bindings.initialValues};
			}
			else {
				func_var = bindings.initialValues;
			}

			$.postJSON('/sr/report/create', func_var,
				function(data){
					if (!data.report) {
						Grape.alert({
							type: 'warning',
							message: 'User does not have the correct permission to run this report',
							title: 'Report Creation Error',
							onClose: function() {
								return;
							}
						});
					}
					else {
						var url = ["/grape-reports/report", String(self.report_definition.report_definition_id()), String(data.report.report_definition_version), String(data.report.report_id)].join('/');
						Finch.navigate(url);
					}
				}
			);
		};

		self.createReport_function = function(dialog_bindings){
			if ( self.report_definition.active() == true ) {
				self.createReportCall(dialog_bindings);
			}
			else {
				Grape.alert_prompt({
					type: 'warning',
					message: 'Do you want to create a report for the old report definition version?',
					title: 'Confirm Report Generation',
					accept_text: 'Yes',
					cancel_text: 'No',
					onClose: function(decision) {
						if (decision === true) {
							self.createReportCall(dialog_bindings);
						}
						else {
							return;
						}
					}
				});
			}
		};

		if (self.report_definition.report_type() === 'function' && self.report_definition.form_scope_id() ) {
			var function_bindings = {
				// title will be remove in future to use title provided in table
				title: 'Please provide parameters',
				scope_id: self.report_definition.form_scope_id(),
				initialValues : {
					report_function_criteria : {}
				}
			};

			Grape.show_dialog('GrapeFormDialog', function_bindings,
			{
				onClose: function(answer) {
					if (answer) {
						function_bindings.initialValues.report_function_criteria = answer;
						self.createReport_function(function_bindings);
					}
					else
						return;
				}
			});
		}
		else {
			self.createReport_function(null);
		}
	};

	self.editReportQuery = function(data){
		var msg = 'Please generate a new report to include the changes made to the report definition';
		Object.assign({}, self.definition);
		// Get the default values of the report definition
		var bindings = {
			initialValues : {
				'report_definition_id': self.report_definition.report_definition_id(),
				'report_definition_name': self.report_definition.title(),
				'report_definition_description': self.report_definition.report_definition_description(),
				'report_definition_group': self.report_definition.report_definition_group(),
				'report_type': self.report_definition.report_type(),
				'query_sql': self.report_definition.query_text() || '',
				'function_schema': self.report_definition.function_schema() || '',
				'function_name': self.report_definition.function_name() || '',
				"form_scope_id": self.report_definition.form_scope_id() || '',
				'report_definition_version': self.report_definition.report_definition_version()
			}
		};

		var callBack = function(result) {
			// Give an alert to inform the user about the changing to new report_definition
			if (result.status === "OK"){
				var url = ["/grape-reports/definition", String(result.report_definition_record.report_definition_id), String(result.report_definition_record.report_definition_version)].join('/');
				Grape.alert({
					type: 'info',
					message: msg,
					title: 'Updating report definition',
					onClose: function() {
						Finch.navigate(url);
					}
				});
			}
			// // Give an alert if no results are found
			else {
				Grape.alert({
					type: 'error',
					message: 'No data match the changes made to report_definiton',
					title: 'No results found'
				});
			}
		};
		// Create report by calling the show_report_definition_dialog
		show_report_definition_dialog(bindings, callBack);
	};

	self.backToReports = function(){
		Finch.navigate('#/grape-reports/');
	};

	self.copyLink = function(data) {
		var url = window.location.href;
		url = url.replace('definition', 'report');
	
		url += '/latest';
		var link = `<a href="${url}">${url}</a>` ;

		var dummy = document.createElement('input'), text = url;
		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		Grape.alert({type:'info', title:data+' Link Copied', message:link});
		document.body.removeChild(dummy);
	};

	self.changeActiveReportDefinition = function(){
		var msg = 'Please confirm if you would like to change active state of this report definition';
		Grape.alert_prompt({
			type: 'warning',
			message: msg,
			title: 'Change Report Definition State',
			accept_text: 'Yes',
			cancel_text: 'No',
			onClose: function(decision) {
				if (decision === true) {
					$.postJSON("/sr/report_definition/change_active", { 'report_definition_id':self.report_definition.report_definition_id(), 'report_definition_version':self.report_definition.report_definition_version() }, function(response){
							if(self.report_definition.active() == false)
								self.report_definition.get_report_definition();
							else
								Finch.navigate('#/grape-reports/');
						}
					);
				}
				else {
					return;
				}
			}
		});
	};
};

var ReportDefinitionPage = function(bindings) {
	var self = this;
	this.self = self;
	self.bindings = bindings;
	self.viewModel = new ReportDefinitionViewModel(this);
	self.name = 'ReportDefinitionPage';

	self.init = function() {
		self.viewModel.report_definition.report_definition_id(self.bindings.report_definition_id);
		self.viewModel.report_definition.report_definition_version(self.bindings.report_definition_version);
	};

	self.updateData = function(){
		self.viewModel.report_definition.get_report_definition();
	};

	self.btnhelp_click = function() {
		Grape.show_help('/sr/help/report_definition_help.html');
	};
};

var report_definition = {
	route: '[/]grape-reports/definition/:report_definition_id/:report_definition_version',
	page_class: ReportDefinitionPage,
	template: template$3
};

var template$2 = "<!-- PAGE -->\n<page-loader params=\"loading: self.loading\"></page-loader>\n<div class=\"div_fixed\">\n\t<div class=\"container-fluid grape\">\n\t\t<div class=\"col-md-11\">\n\n\t\t\t<div class=\"col-md-1\"></div>\n\t\t\t<div class=\"col-md-10\" style=\"text-align:center;\">\n\t\t\t\t<span style=\"display:inline;\" class=\"page_header\">\n\t\t\t\t\t<span data-bind=\"text: report.title\"></span>\n\t\t\t\t\t<span><i class=\"fa fa-question-circle help_icon fa-2x\" data-autobind=\"btnhelp\"></i></span>\n\t\t\t\t</span>\n\t\t\t<br>\n\t\t\t\t<span style=\"margin: auto;\" data-bind=\"text: report.description\"></span>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-1\"></div>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<div class=\"container-fluid grape\">\n\t\t<div class=\"col-md-12 pull-left\">\n\t\t\t<button class=\"btn btn-primary back_button\" data-bind=\"click:backToReportDefinition\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Navigate to Reports Page.\">\n\t\t\t\t\t<span class=\"fa fa-lg fa-chevron-left\"></span> Back to Report Definition\n\t\t\t</button>\n\n\t\t\t<button id=\"email\" class=\"btn btn-primary envelope-o\" data-bind=\"click: send_to_email\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Email\">\n\t\t\t\t\t<span class=\"fa fa-file-text-o\"></span> Send To Email List\n\t\t\t\t</button>\n\n\t\t\t\t<button id=\"export-to-csv\" class=\"btn btn-primary back_button\" data-bind=\"click: downloadCSV\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Export selected leads to CSV\">\n\t\t\t\t\t<span class=\"fa fa-file-text-o\"></span> Export to CSV\n\t\t\t\t</button>\n\n\t\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: copyLink\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Copy report link to clipboard\">\n\t\t\t\t\t<span class=\"fa fa-clone\"></span> Copy link\n\t\t\t\t</button>\n\n\t\t\t\t<button class=\"btn btn-primary refresh\" data-bind=\"click:refreshReportResults\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Refresh For Latest Data.\">\n\t\t\t\t\t<span class=\"fa fa-refresh\"></span>\n\t\t\t\t</button>\n\n\t\t\t\t<!-- ko if: report.flag() == true -->\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" name=\"toggle\" aria-label=\"toggle\" title=\"Delete Report\" data-bind=\"click: cancelProcessReports\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<span class=\"glyphicon glyphicon-remove\"></span>\n\t\t\t\t\t</button>\n\t\t\t\t<!-- /ko -->\n\t\t\t\t<!-- ko if: report.flag() == false -->\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" name=\"toggle\" aria-label=\"toggle\" title=\"Cancel Report Generation\" data-bind=\"click: cancelProcessReports\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<span class=\"glyphicon glyphicon-remove\"></span>\n\t\t\t\t\t</button>\n\t\t\t\t<!-- /ko -->\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"container-fluid grape\">\n\t<div class=\"col-md-12\">\n\t\t<div id=\"report_message_div\" class=\"alert alert-info clearfix\">\n\t\t\t<span data-bind=\"text: report.report_status_message\"></span>\n\t\t</div>\n\t\t<div id=\"loading\" class=\"loading-2\">\n\t\t\t<div class=\"loading-center-2\">\n\t\t\t\t<div class=\"loading-center-relative\">\n\t\t\t\t\t<div class=\"object\" id=\"object_four\"></div>\n\t\t\t\t\t<div class=\"object\" id=\"object_three\"></div>\n\t\t\t\t\t<div class=\"object\" id=\"object_two\"></div>\n\t\t\t\t\t<div class=\"object\" id=\"object_one\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"column\" class=\"report_content\">\n\t\t\t\t<table class=\"table\" id=\"result_table\"></table>\n\t\t\t</div>\n\t\t\t<div class=\"pull-right\">\n\t\t\t\t<button class=\"btn btn-primary back_button\" data-bind=\"click:backToTop\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Back To Top.\">\n\t\t\t\t\t\t<span class=\"fa fa-arrow-up\"></span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";

var ReportViewModel = function(page)
{
	var self = this;
	this.self = self;
	self.page = page;
	self.report_definition = ko.observable();
	self.report = {
		title: ko.observable('Placeholder'),
		description: ko.observable('Placeholder'),
		query: {
			query_sql: ko.observable('')
		},
		report_status_message: ko.observable(''),
		report_id: self.page.bindings.report_id,
		schedule_id: ko.observable(),
		report_created_date: ko.observable(),
		flag: ko.observable(false),
		run_time: ko.observable()
	};

	// self.loading = ko.observable(false);

	self.report_definition_id = self.page.bindings.report_definition_id;
	self.report_definition_version = self.page.bindings.report_definition_version;
	self.email_list = ko.observableArray([]);
	var columns = [];
	var col_names;
	var report_data;

	self.report.navigation_url = function(result_table){
		// When the url is sent through with 'new' generate a new report
		if(self.page.bindings.report_id === 'new'){
			self.report_definition.subscribe(function(newValue) {
				self.refreshReportResults();
			});
		}
		// When the url is sent through with 'latest' display the latest report
		else if(self.page.bindings.report_id === 'latest'){
			$.postJSON("grape/list",
			{
				schema: 'sr',
				tablename: 'report',
				sortfield: 'report_id',
				sortorder: 'DESC',
				limit: '1'
			},
			function(response){
				self.getResults(response.records[0].report_id);
			});
		}
		else
			self.getResults(self.page.bindings.report_id);
	};

	self.getResults = function(collected_report_id) {
		var table = $(result_table);
		$("#loading").hide();

		// Select or generate the report corresponding with the query or the function
		$.postJSON('/sr/report/report_get_results',
			{
				"report_id": collected_report_id
			},
			function(data){
				report_data = data.metadata;
				self.report.report_created_date(data.metadata.date_inserted);
				if (data.status === 'ERROR' || ['Error', 'Completed', 'NewTask', 'Running'].indexOf(data.report_status) < 0 )
				{
					Grape.alert(
						{type: 'warning', title: 'Unknown error', message: 'We have encountered an unknown error. Please contact IT support to look into this matter'}
					);
					return null;
				}
				if (data.report_status === "Error")
				{
					self.report.report_status_message(data.report);
				}
				else if (data.report_status === "Completed")
				{
					self.report.report_status_message('');
					$("#report_message_div").hide();
					col_names = Object.keys(data.report[0]);
					$("#loading").hide();
					self.report.run_time(data.run_time);
					for (var i =0; i < col_names.length; i++)
					{
						columns.push({	field: col_names[i], title: col_names[i]});
						data.report = data.report;
					}

					table.bootstrapTable({
						classes: 'table table-no-bordered table-condensed table-responsive',
						pagination: true,
						sidePagination: 'client',
						paginationVAlign: 'both',
						columns: columns,
						striped: true,
						pageSize: 50,
						totalRows: (data.report).length,
						data: data.report,
					});
					self.report.flag(true);
				}
				else
				{
					if (data.report_status === "Running")
					{
						self.report.report_status_message(data.report);
					}
					else if (data.report_status === "NewTask")
					{
						self.report.report_status_message(data.report);
					}
					// Try again in 2000 milliseconds
					$("#loading").show();
					self.timer = setTimeout(
						function(){
							$("#loading").hide();
							self.getResults(collected_report_id);
						},
						2000
					);
				}
			}
		);
	};

	self.downloadCSV = function() {
		var formatted_date = new Date(self.report.report_created_date());
		var export_filename = self.report.title()+' v'+self.report.report_id+'('+formatted_date.getFullYear() + "-" + (formatted_date.getMonth() + 1) + "-" + formatted_date.getDate() + " " + formatted_date.getHours() + ":" + formatted_date.getMinutes() + ":" + formatted_date.getSeconds()+').csv';
		window.open('/grape-reports/'+self.report.report_id+'/export/csv/'+export_filename, '_blank');
	};

	self.send_to_email = function(v,e) {
		var email_params = {
			schema: 'sr',
			tablename: 'user_email_list',
			sortfield: 'list_id',
			limit: 5000
		};

		$.postJSON("/grape/list", email_params, function(results){
			if (results.result_count == 0){
			 	results.records = [];
			}			self.email_list([]);

			results.records.forEach(function(record) {
				self.email_list.push({'value': record.list_id, 'text': record.title});
			});

			Grape.show_dialog('GrapeFormDialog',
			{
				title: 'Specify email list for report link',
				formDef : {
					fields: [
						{
							name: 'email_list_id',
							label: 'Select Email List',
							type: 'ChoiceField',
							args: {
								options: self.email_list()
							}
						}
					]
				}
			},
			{
				onClose: function(answer) {
					if (answer) {
						$.postJSON('/sr/email',
						{
							report_id: self.page.bindings.report_id,
							email_list_id: answer.email_list_id,
							url: ["/grape-reports/report", String(self.report_definition_id), String(self.report_definition_version),String(self.page.bindings.report_id)].join('/')
						},
						function(data){
							if (data.status === 'ERROR')
							{
								Grape.alert(
									{type: 'warning', title: 'Unknown error', message: 'We have encountered an unknown error. Please contact IT support to look into this matter'}
								);
								return null;
							}
						}
					);}
					else
						return;
					self.email_list.removeAll();
				}
			});
		});
	};

	self.backToReportDefinition = function() {
		Finch.navigate('#/grape-reports/definition/' + String(self.report_definition_id) + '/' + String(self.report_definition_version));
	};

	self.refreshReportResults = function() {
		$.postJSON('/sr/report/create',
			{
				report_definition_id: self.page.bindings.report_definition_id,
				report_definition_version: self.page.bindings.report_definition_version,
				report_function_criteria: report_data.report_function_criteria
			},
			function(data){
				var url = ["/grape-reports/report", String(self.report_definition_id), String(data.report.report_definition_version), String(data.report.report_id)].join('/');
				Finch.navigate(url);
			}
		);
	};

	self.cancelProcessReports = function(data){
		var prompt_parameters = {};
		if (self.report.flag()) {
			prompt_parameters = {
				type: 'warning',
				title: 'Delete Report',
				message: 'Delete the generated report and return to Report Definition page'
			};
		}
		else {
			prompt_parameters = {
				type: 'warning',
				title: 'Cancel Process',
				message: 'Cancel the create report process and return to Report Definition page',
			};
		}
		var options = {
			onClose: function(decision) {
				if (decision === true) {
					var url = ["#/grape-reports/definition", String(self.report_definition_id), String(self.report_definition_version)].join('/');
					$.postJSON("/sr/report_process/delete",	{'report_id': self.report.report_id}, function(process_cancel_result){
						if(process_cancel_result != -1){
							$("#loading").hide();
							self.report.report_status_message('Report creation was canceled');
							clearTimeout(self.timer);
							Finch.navigate(url);
						}
						else
							Grape.alert(
								{type: 'warning', title: 'Unknown error', message: 'We have encountered an unknown error. Please contact IT support to look into this matter'}
							);
					});
				}
				else
					return;
			}
		};
		options = Object.assign(options, prompt_parameters);
		Grape.alert_prompt(options);
	};

	self.backToTop = function() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	};

	self.copyLink = function() {
		var url = window.location.href;
		var link = `<a href="${url}">${url}</a>`;
		var dummy = document.createElement('input'), text = url;
		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		Grape.alert({type:'info', title:'Report Link Copied', message:link});
		document.body.removeChild(dummy);
	};
};

var ReportPage = function(bindings) {
	var self = this;
	this.self = self;
	self.bindings = bindings;
	self.viewModel = new ReportViewModel(self);
	self.name = 'ReportPage';

	self.init = function() {
		// Fetch report definition based on the report definition id
		$.postJSON("/grape/list",
			{
				schema: 'sr',
				tablename: 'report_definition',
				filter: [
					{field: 'report_definition_id', operand: '=', value: bindings.report_definition_id }
				]
			},
			function(response){
				var report_definition = response.records[0];
				self.viewModel.report.title(report_definition.report_definition_name);
				self.viewModel.report.description(report_definition.report_definition_description);
				self.viewModel.report_definition(report_definition);
			}
		);
	};

	self.updateData = function() {
		self.viewModel.report.navigation_url('#result_table');
	};

	self.teardown = function() {
		clearTimeout(self.viewModel.timer);
	};

	self.btnhelp_click = function() {
		Grape.show_help('/sr/help/report_help.html');
	};
};

var report = {
	route: '[/]grape-reports/report/:report_definition_id/:report_definition_version/:report_id',
	page_class: ReportPage,
	template: template$2
};

var template$1 = "<!-- PAGE -->\n<page-loader params=\"loading: self.loading\"></page-loader>\n<div class=\"container grape\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<span class=\"page_header\"> Email User Lists\n\t\t\t\t<i class=\"fa fa-question-circle help_icon\" data-autobind=\"btnhelp\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n<hr>\n<div class=\"container grape\">\n\t<div class=\"row\">\n\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t<div class=\"columns columns-right btn-group pull-right\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" name=\"toggle\" aria-label=\"toggle\" title=\"Add Email List\" data-bind=\"click: email_user_list.add_email_list\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t<i class=\"glyphicon glyphicon-plus\" style=\"data-buttons-align\"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<table id=\"email_userlist_table\"></table>\n\t\t</div>\n\t</div>\n</div>\n";

var EmailUserListViewModel = function(page)
{
	var self = this;
	this.self = self;
	self.page = page;
	var email_role_list = [];
	var email_id_list = [];

	self.email_user_list = {
		list: ko.observableArray([])
	};

	// Limit set for future use if roles exceed 50
	var role_params = {
		schema: 'sr',
		tablename: 'v_access_roles'
	};

	$.postJSON("/grape/list", role_params, function(results){
		if (results.result_count == 0){
			results.records = [];
		}
		results.records.forEach(function(record) {
			email_role_list.push({"list_value_field": record.role_name, "list_label_field": record.role_name});
		});
	});

	var user_id_params = {
		schema: 'sr',
		tablename: 'v_users'
	};

	$.postJSON("/grape/list", user_id_params, function(results){
		if (results.result_count == 0){
			results.records = [];
		}
		results.records.forEach(function(record) {
			email_id_list.push({"list_value_field": record.user_id, "list_label_field": record.username});
		});
	});

	self.email_user_list.get_user_email_list = function(){
		var params = {
			schema: 'sr',
			tablename: 'user_email_list',
			sortfield: 'list_id',
			limit: 5000
		};

		$.postJSON("/grape/list", params, function(results){
			if (results.result_count == 0){
				results.records = [];
			}			self.email_user_list.list(results.records);
		});
	};

	self.email_user_list.edit_email_list = function(data) {
		var bindings = {
			initialValues : {
				'list_id': data.list_id,
				'title': data.title,
				'owner_id': data.owner_id,
				'users': data.users,
				'roles': data.roles,
				'address_strings': data.address_strings
			},
			user_list : email_id_list,
			roles : email_role_list
		};

		var callBack = function(result){
			self.email_user_list.get_user_email_list();
		};
		user_email_list_dialog(bindings, callBack);
	};

	self.email_user_list.add_email_list = function(data) {
		var bindings = {
			initialValues : {},
			user_list : email_id_list,
			roles : email_role_list
		};

		var callBack = function(result){
			self.email_user_list.get_user_email_list();
		};
		user_email_list_dialog(bindings, callBack);
	};
};

var EmailUserListPage = function(bindings) {
	var self = this;
	this.self = self;
	self.bindings = bindings;
	self.viewModel = new EmailUserListViewModel(this);
	self.name = 'EmailUserListPage';
	self.table = $("#email_userlist_table");

	self.init = function() {
		self.viewModel.email_user_list.list.subscribe(function(newValue) {
			self.table.bootstrapTable('load',newValue);
		});

		var columns = [
			{field: 'title', title: 'Email List Title', searchable: true},
			{field: 'owner_id', title: 'Owner Id'},
			{field: 'users', title: 'User Linked Ids'},
			{field: 'roles', title: 'User Roles'},
			{field: 'address_strings', title: 'Linked User Emails'}
		];

		self.table.bootstrapTable({
			classes: 'table table-no-bordered table-condensed table-responsive',
			pagination: true,
			search: true,
			sortable: true,
			sortOnEnterKey: true,
			sidePagination: 'client',
			dataId: 'list_id',
			columns: columns,
			striped: true,
			pageSize: 100,
			onClickRow: function(row) {
				self.viewModel.email_user_list.edit_email_list(row);
			},
			rowStyle: function(row, index) {
						return {
							css: {"cursor": "pointer"}
						};
			},
			totalRows: 0
		});
	};

	self.updateData = function(){
		self.viewModel.email_user_list.get_user_email_list();
	};

	self.btnhelp_click = function() {
		Grape.show_help('/sr/help/email_user_list_help.html');
	};
};

var email_user_list = {
	route: '[/]grape-reports/email_user_list',
	page_class: EmailUserListPage,
	template: template$1
};

var template = "<!-- <page-loader params=\"loading: self.loading\"></page-loader> -->\n<div class=\"container-fluid grape\">\n\t<div class=\"col-md-12\">\n\t\t<div class=\"col-md-2\"></div>\n\t\t\t<div class=\"col-md-8\">\n\t\t\t\t<span class=\"page_header\">Auto Scheduler List\n\t\t\t\t\t<i class=\"fa fa-question-circle help_icon\" data-autobind=\"btnhelp\"></i>\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t<div class=\"col-md-2\"></div>\n\t</div>\n</div>\n\n<hr>\n<div class=\"container-fluid grape\">\n\t<div class=\"col-md-12\">\n\t\t<div class=\"fixed-table-toolbar\">\n\t\t\t<div class=\"columns columns-right btn-group pull-right\">\n\t\t\t\t<div>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" name=\"toggle\" aria-label=\"toggle\" title=\"Add Report Schedule\" data-bind=\"click: report_autoscheduler.autoscheduling_edit_or_create\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"fa fa-plus\" style=\"data-buttons-align\"></i>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" name=\"toggle\" aria-label=\"toggle\" title=\"Show /  Hide inactive\" data-bind=\"click: report_autoscheduler.show_inactive\" data-visible-roles=\"sr.admin\">\n\t\t\t\t\t\t<i class=\"fa fa-eye-slash\" style=\"data-buttons-align\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<table id=\"autoscheduler_table\"></table>\n\t\t</div>\n\t</div>\n</div>\n";

var scheduledReportViewModel = function(page)
{
	var self = this;
	var report_def_list = [];
	var email_list = [{title: 'none', id: ""}];
	self.table = $("#autoscheduler_table");

	self.report_autoscheduler = {
		process_id: ko.observable('Placeholder'),
		process_name: ko.observable('Placeholder'),
		list: ko.observableArray([]),
		report_definition_id_list: ko.observableArray([]),
		email_id_list: ko.observableArray([]),
		show_hide_active_schedules: ko.observable()
	};

	self.report_autoscheduler.get_autoscheduler_list = function(){
		// Get auto scheduler data from db
		$.postJSON("/sr/autoscheduler/load", {'run_with_params': 'report_definition_id', 'show_hide_active_schedules': self.report_autoscheduler.show_hide_active_schedules()}, function(results){
			if (results.records == null){
			 	results.records = [];
			}
			self.report_autoscheduler.list(results.records);
		});

		// Get report definition information from db
		var report_params = {
			schema: 'sr',
			tablename: 'report_definition',
			sortfield: 'report_definition_id',
			filter: [
				{field: 'active', operand: '=', value: true}
				],
			limit: 5000
		};

		$.postJSON("/grape/list", report_params, function(results){
			if (results.result_count == 0){
			 	results.records = [];
			}
			var report_definition_ids = [];
			results.records.forEach(function(record) {
				if(report_definition_ids.indexOf(record.report_definition_id) == -1){
					report_definition_ids.push(record);
				}
			});
			self.report_autoscheduler.report_definition_id_list(report_definition_ids);
		});

		// Get email list information from db
		var email_params = {
			schema: 'sr',
			tablename: 'user_email_list',
			sortfield: 'list_id',
			limit: 5000
		};

		$.postJSON("/grape/list", email_params, function(results){
			if (results.result_count == 0){
			 	results.records = [];
			}
			var list_ids = [];
			results.records.forEach(function(record) {
				if(list_ids.indexOf(record.list_id) == -1){
					list_ids.push(record);
				}
			});
			self.report_autoscheduler.email_id_list(list_ids);
		});

		var days_of_week_formatter = function(value, row, index) {
			var days_of_week = '';
			if (row.dow.substr(0,7) === '0000000' || row.dow.substr(0,7) === '1111111') {
				days_of_week = 'N/A';
			}
			else {
				row.dow.substr(0,1) === '1' ? days_of_week += 'Sun /' : days_of_week += '_ / ';
				row.dow.substr(1,1) === '1' ? days_of_week += 'Mon /' : days_of_week += '_ / ';
				row.dow.substr(2,1) === '1' ? days_of_week += 'Tues /' : days_of_week += '_ / ';
				row.dow.substr(3,1) === '1' ? days_of_week += 'Wed /' : days_of_week += '_ / ';
				row.dow.substr(4,1) === '1' ? days_of_week += 'Thur /' : days_of_week += '_ / ';
				row.dow.substr(5,1) === '1' ? days_of_week += 'Fri /' : days_of_week += '_ / ';
				row.dow.substr(6,1) === '1' ? days_of_week += 'Sat' : days_of_week += '_';
			}
			return days_of_week;
		};

		var time_sched_formatter = function(value, row, index) {
			var time_sched;
			if (row.time_sched) {
				time_sched = row.time_sched.substr(0,10) + ' ' + row.time_sched.substr(11,5);
			}

			return time_sched;
		};

		$.postJSON("/grape/list",
			{schema: 'grape_processes', tablename: 'process', filter: [{field: 'process_name', operand: '=', value: 'report_create'}] },
			function(results){
				if(results.status === "ERROR"){
					alert(results.message);
					return;
				}
				else if (results.result_count == 0){
				 	self.table.before("<div>No Results Found</div>");
					return;
				}
				else {
					var record = results.records[0];
					self.report_autoscheduler.process_name(record.process_name);
					self.report_autoscheduler.process_id(record.process_id);

					var columns = [
						{field: 'report_definition_name', title: 'Report to be Run', searchable: true, width:'25%'},
						{field: 'run_as_user', title: 'Run As User', sortable: true, width:'5%'},
						{field: 'scheduled_interval', title: 'Scheduled Interval', sortable: true, width:'5%'},
						{field: 'days_of_week', title: 'Run On These Days', sortable: true, formatter: days_of_week_formatter, width:'15%'},
						{field: 'days_of_month', title: 'Days Of Month', sortable: true, width:'8%'},
						{field: 'day_time', title: 'Run On This Time', sortable: true, width:'5%'},
						{field: 'schedules', title: 'Schedules', sortable: true, width: '10%', formatter: time_sched_formatter},
						{field: 'title', title: 'Send to Email List', searchable: true, width:'15%'},
						{field: 'active', title: 'Active', sortable: true, width:'5%'}
					];

					self.table.bootstrapTable({
						classes: 'table table-no-bordered table-condensed table-responsive table-hover',
						pagination: true,
						search: true,
						sortable: true,
						sortName: 'active',
						sortOrder: 'desc',
						sortOnEnterKey: true,
						sidePagination: 'client',
						data: self.report_autoscheduler.list(),
						columns: columns,
						striped: true,
						pageSize: 100,
						onClickRow: function(row) {
							self.report_autoscheduler.autoscheduling_edit_or_create(row);
						},
						rowStyle: function(row, index) {
							return {
								css: {"cursor": "pointer"}
							};
						},
						totalRows: 0
				// 		detailView: true,
				// 		detailFormatter: function(index, row, element) {},
				// 		onExpandRow: function(index, row, detail) {},
				// 		onCollapseRow: function(index, row, detail) {}
				// 	});
				// };
					});
				}
			}
		);
	};

	self.report_autoscheduler.autoscheduling_edit_or_create = function(arg, event) {
		var mode;
		if(event === undefined)
			mode = 'edit';
		else
			mode = 'create';

		var default_value_report_def;
		var default_value_email;
		var auto_scheduler;
		var auto_schedulers;

		$.postJSON('/sr/access_role_check', { process_id: self.report_autoscheduler.process_id() }, function(data){
			if (data.result.output === false) {
				Grape.alert({
					type: 'warning',
					message: 'User does not have the correct permission to run autoscheduling',
					title: 'Report Autoscheduling Error',
					onClose: function() {
						return;
					}
				});
			}
			else
			{
				self.report_autoscheduler.report_definition_id_list().forEach(function(record) {
					report_def_list.push({"id": record.report_definition_id, "title": record.report_definition_name});
				});

				self.report_autoscheduler.email_id_list().forEach(function(record) {
					email_list.push({"id": record.list_id, "title": record.title});
				});

				if(mode === 'edit')
				{
					auto_scheduler = arg;
					auto_schedulers = [arg];
					default_value_report_def = arg.report_definition_id;
					default_value_email = arg.list_id;
				}
				else
				{
					auto_scheduler = {};
					auto_schedulers = [];
					default_value_report_def = null;
					default_value_email = '';
				}

				var process = {
					process_name: self.report_autoscheduler.process_name(),
					process_id: self.report_autoscheduler.process_id(),
					ui_param : [
						{
							"name": "report_definition_id",
							"label": "Select Report to run:",
							"type": "list",
							"list": report_def_list,
							"list_label_field": "title",
							"list_value_field": "id",
							"default_value": default_value_report_def
						},
						{
							"name": "email_list_id",
							"label": "Email list to be mailed when report is finished:",
							"type": "list",
							"list": email_list,
							"list_label_field": "title",
							"list_value_field": "id",
							"default_value": default_value_email
						}
					],
					auto_schedulers : auto_schedulers
					// self.report_autoscheduler.list()
				};

				Grape.show_dialog(
					'AutoSchedulerDialog',
					{
						process: process,
						autoscheduler: auto_scheduler
					},
					{
						onClose: function(result) {
							self.report_autoscheduler.get_autoscheduler_list();
							report_def_list = [];
							email_list = [];
						}
					}
				);
			}
		});
	};

	self.report_autoscheduler.show_inactive = function() {
		self.report_autoscheduler.show_hide_active_schedules( !self.report_autoscheduler.show_hide_active_schedules());
	};
};

var ScheduledReportPage = function(bindings) {
	var self = this;
	this.self = self;
	self.bindings = bindings;
	self.viewModel = new scheduledReportViewModel(this);
	self.name = 'ScheduledReportPage';

	self.init = function() {
		self.viewModel.report_autoscheduler.list.subscribe(function(newValue) {
			self.viewModel.table.bootstrapTable('load', newValue);
		});

		self.viewModel.report_autoscheduler.show_hide_active_schedules.subscribe(function(new_value){
			self.updateData();
		});
	};

	self.updateData = function(){
		self.viewModel.report_autoscheduler.get_autoscheduler_list();
	};

	self.btnhelp_click = function() {
		Grape.show_help('/sr/help/report_autoscheduler_help.html');
	};
};

var report_autoscheduler = {
	route: '[/]grape-reports/report_autoscheduler',
	page_class: ScheduledReportPage,
	template: template
};

var pages = [
	report_menu,
	report_definition,
	report,
	email_user_list,
	report_autoscheduler
];

/*components.forEach(function (component) {
	// Load all knockout components exported by the components index file
	if (!component.module_type || component.module_type == 'ko')
	{
		console.log('registering component', component);
		ko.components.register(component.name, {
			template: component.template,
			viewModel: component.viewModel
		});
	}
});
*/
// Register all grape dialogs exported by the dialogs index file
dialogs.forEach(function (dialog) {
	window.Grape.dialogs[dialog.name] = {
		pageClass: dialog.dialog_class,
		template: dialog.template
	};

});

// Register all pages exported by the pages index file
pages.forEach(function (page) {
	console.log('Registering page', page);
	window.Grape.route(page.route, page);
});
/*
//Register all grape cache entries exported by the caches index file
appcaches.forEach(function (cache) {
	Grape.cache.register(
		cache.name,
		cache.options
	);
});
*/
//# sourceMappingURL=grape-reports.js.map
